<template>
	<popup
			:fullscreen="false"
			@updateClosePopup="onCloseDialog"
			@updateSave="onSave"
			height-head="40px"
			width="340"
			btn-text="SAVE"
			title="Enter new role"
	>
		<field
				margin="10px 0 20px 0"
				width="300px"
				label="Role name"
				placeholder="Enter name"
				@updateInput="onInput"
				:setInputValue="name"
		></field>
		<field
				margin="10px 0 20px 0"
				overflow="hidden"
				width="24px"
				padding="0"
				height="24"
				label-switch="Customer"
				:switch-value="type"
				@updateSwitch="onCheckbox"
				is-dense
				is-switch
				is-off-style
		></field>
		<field
				v-if="type"
				margin="0 0 20px 0"
				width="300px"
				label="Select customer"
				placeholder="Select customer"
				@updateAutocomplete="onAutocomplete($event)"
				:autocompleteValue="customerId"
				:items="permissionCustomers"
				is-autocomplete
				:is-clearable="false"
		></field>
	</popup>
</template>

<script>
import Popup from "@/shared/Popup/Popup";
import { mapActions } from "vuex";

export default {
	name: "RolesForm",
	components: { Popup },
	props: {
		permissionCustomers: Array,
		defaultCustomerId: Number
	},
	data: () => ({
		name: "",
		type: false,
		subrole: 0,
		customerId: null,
	}),
	methods: {
		...mapActions([ "actionPreloader", "setAlert", "onNewRole" ]),
		async onSave() {
			this.actionPreloader(true);
			const subrole = +Boolean(this.customerId);
			const customer_id = subrole ? this.customerId : 0;

			const values = {
				name: this.name,
				type: Number(this.type),
				subrole,
				customer_id,
			};

			const { id, error } = await this.onNewRole(values);
			if (id) {
				this.setAlert({ type: "success", message: "Adding new role was successfully" });
				this.$emit("updateRolesList");
				this.onCloseDialog();
			} else if (error?.name) {
				this.setAlert({ type: "error", message: error.name[0] });
			} else {
				this.setAlert({ type: "error", message: "Saving Error" });
			}
		},
		onCloseDialog() {
			this.$emit("updateCloseDialog");
		},
		onCheckbox({ value }) {
			this.type = value;
		},
		onSelect({ value }) {
			this.customerId = value?.id ?? value;
		},
		onAutocomplete({ value }) {
			this.customerId = value?.id ?? value;
		},
		onInput({ value }) {
			this.name = value;
		}
	},
	mounted() {
		if (this.defaultCustomerId) {
			this.customer_id = this.permissionCustomers.find(item => item.id === this.defaultCustomerId)?.id;
			this.type = 1;
		}
	},
};
</script>

<style scoped lang="scss">

</style>
